<div class="row" class="row border Page-Header">
    <div class="col-12 p-0">
      <h6 class="HeadContent">Question Monthly Count Report</h6>
    </div>
  </div>

  <div class="row pt-1">
    <div class="col-12" *ngIf="QuestionMonthlyCount">
<app-tinyedneditor [QuestionMonthlyCount]="QuestionMonthlyCount"></app-tinyedneditor>
    </div>
  </div>
  <!-- <div class="row" *ngIf="QuestionMonthlyCount" >
    <div class="col-12" style="overflow: scroll;min-height: 85vh !important;max-height:  60vh;height: 60vh;margin-right:2px;">
      <div class="table-responsive">
      <table id="QuestionCount" class="table table-striped table-bordered table-sm">
        <thead>
          <tr class="table-secondary">
            <th class="col-md-1 centertext">Year</th>
            <th class="col-md-1 centertext">Month</th>
            <th class="col-md-4 centertext">Name</th>
            <th class="col-md-1 centertext">Created</th>
            <th class="col-md-1 centertext">Updated</th>
            <th class="col-md-1 centertext">Reviewed</th>
            <th class="col-md-1 centertext">Approved</th>
          </tr>
        </thead>
        <tbody>
         
          <tr *ngFor="let s of QuestionMonthlyCount;let i=index">
            <td class="centertext">{{s.Year}}</td>
            <td  class="centertext">{{s.Month}}</td>
            <td>{{s.Name}}</td>
            <td class="centertext">{{s.Created}}</td>
            <td class="centertext">{{s.Updated}}</td>
            <td class="centertext">{{s.Reviewed}}</td>
            <td class="centertext">{{s.Approved}}</td>
          </tr>
        </tbody>
      </table>
    </div>
</div>
</div> -->
